import script from "./ChangePasswordSended.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePasswordSended.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__